// extracted by mini-css-extract-plugin
export var circle = "_dn-1";
export var exitConfirmationModal = "_dn-5";
export var iframe = "_dn-0";
export var offline = "_dn-3";
export var online = "_dn-2";
export var workstationSelectError = "_dn-4";